<mat-card>
    <mat-card-header>
        <mat-card-title>INSTRUCTIONS</mat-card-title>
        <mat-card-subtitle>Last updated Jul 11, 2024</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>

        <h3>TABLE OF CONTENTS</h3>
        <ul>
            <li>Yard View</li>
            <li>Add Yard Spot</li>
            <li>Moves</li>
            <li>Assign Moves</li>
            <li>Moves History</li>
            <li>Trailers</li>
            <li>Instances</li>
            <li>FAQ</li>
        </ul>
        <p>Note that the shipper role represents all of the tasks available on the <a href="https://yardhostle.com">shipper portal</a></p>
        <p>and the driver role represents all of the tasks available on the <a href="https://driver.yardhostle.com">driver portal</a></p>
        
        <h3>Yard View</h3>
        <iframe src="https://scribehow.com/embed/Managing_all_yard_view_tasks__eL5hEydgTAiz8RuUlBFf1g" width="100%" height="640" allowfullscreen frameborder="0"></iframe>

        <h4>Shipper Roles</h4>
        <p>Yard view is the main page of the application. It displays all the trailers in the yard.</p>
        
        <p>Each yard location is represented by a card with the following information: </p>
        <ul>
            <li>Yard spot #</li>
            <li>Yard Location Status</li>
            <li>PO</li>
            <li>Trailer #</li>
            <li>Carrier</li>
            <li>Trailer Status</li>
        </ul>
        <p>The yard location can be marked as out of service</p>
        <p>The yard trailer can be marked as lost</p>
        <p>A trailer can be added to a empty yard location</p>
        <p>A trailer can be checked out if it has a trailer attached to it</p>
        <p>A trailer can be updated</p>
        <h4>Driver roles</h4>
        <p>The driver can only see the yard</p>

        <h3>Add Yard Spot</h3>
        <iframe src="https://scribehow.com/embed/Add_Yard_Spot_With_Trailer_on_Yardhostle_Platform__3F0NEYrjSK6uNTJdHekWdg" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
        <h4>Shipper Role</h4>
        <p>A new trailer can be checked in if there are empty yard locations available</p>
        <p>A new yard location can be created with a trailer or without</p>
        <h4>Driver Role</h4>
        <p>Driver does not have access to this page.</p>
        
        <h3>Moves</h3>
        <iframe src="https://scribehow.com/embed/Moves_on_YardHostle_Website__pXSX_z8QRYmxgy1o8wP7Uw" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
        <h4>Shipper roles</h4>
        <p>Shipper can view the driver currently assigned moves</p>
        <p>Shipper can view the assignment where they can then reroute the an empty yard location or complete the task</p>
        <h4>Driver roles</h4>
        <p>Driver can view the moves assigned to them</p>
        <p>Driver can view the assignment where they can then reroute the an empty yard location or complete the task</p>
        
        <h3>Assign Moves</h3>
        <iframe src="https://scribehow.com/embed/Assign_moves_on_YardHostle_website__LImzZgd3RoCKV75AeM-VGA" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
        <p>Assignments can be made for the driver</p>
        <h3>Moves History</h3>
        <p>A list of completed moves can be viewed</p>
        
        <h3>Trailers</h3>
        <iframe src="https://scribehow.com/embed/Select_Trailer_Status_and_Confirm_Empty_Capacity__5OM6p5HwSTiiFQH79w5LbA" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
        <p>A list of trailers can be viewed</p>
        
        <h3>Instances</h3>
        <p>Currently unavailable</p>
        <p>A list of instances can be viewed</p>
        <h3>FAQ</h3>
        <ul>
            <li>
                <p>Q:Where do I find the login credentials for the driver?</p>
                <p>A:For the time being both the shipper an the driver are sharing the same credentials.</p>
                <p>It is intended to eventually add the seperate credentials to the driver and even add the functionality to add additional drivers on the same instance.</p>
            </li>
            <li>
                <p>Q: Do you offer more than one instance?</p>
                <p>A: For the time being no, but that is a feature that intended to be added in the nead future.</p>
            </li>
            <li>
                <p>Q: What's the deal with the android app?</p>
                <p>A: the android app is intended to compliment the driver. It is an alternative to the<a href="Https://driver.yardhostle.com"> web driver portal</a> either one can be used interchangeably.</p>
            </li>
        
        </ul>
    </mat-card-content>
</mat-card>
